import {
	jsonToUrlParams,
	removeNilOrEmptyObj,
	trimObjectValues,
} from '@/utils';

import api, {
	GetDashboardStatisticParams,
	GetForeignApplicantListParams,
	GetForeignApplicantListsDetailParams,
	GetForeignApplicantProgramListResponse,
	GetForeignProgramApplicantListParams,
	GetForeignProgramApplicantListResponse,
	GetForeignProgramDetailResponse,
	GetForeignProgramListParams,
	GetForeignProgramListResponse,
	GetForeignUserListParams,
	TCreateForeignApplicantRequest,
	TCreateForeignUserRequest,
	TGetListContractedKoreanBusinessParams,
} from '.';

/* ---- FOREIGN DASHBOARD START---- */
export const getForeignDashboardStatistic = async ({
	...rest
}: GetDashboardStatisticParams) =>
	await api.get(`/foreign/dashboard/statistical?${jsonToUrlParams(rest)}`);

export const getContractedKoreanBusiness = async (
	params: TGetListContractedKoreanBusinessParams
) => {
	const { page, pageSize, allData = false } = params;
	return await api.get(
		`/foreign/unit/domesticUnitList?${jsonToUrlParams({ page, pageSize, allData })}`
	);
};

/* ---- FOREIGN DASHBOARD END---- */

/* ---- FOREIGN UNIT START---- */
export const getForeignUnitBasicInfo = () => api.get('/foreign/unit/basicInfo');

export const getForeignDomesticUnitList = (allData: boolean) =>
	api.get('/foreign/unit/domesticUnitList', { params: { allData } });

/* ---- FOREIGN UNIT END---- */

/* ---- FOREIGN USER START---- */
export const getForeignUserList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	...rest
}: GetForeignUserListParams) =>
	await api.post(
		`/foreign/user/list?${jsonToUrlParams({ page, pageSize, allData, sortSql })}`,
		rest
	);

export const getForeignUserDetail = async (id: number) =>
	await api.get(`/foreign/user/detail?id=${id}`);

export const deleteForeignUser = async (ids: number[]) =>
	await api.post('/foreign/user/delete', ids);

export const createForeignUser = async (data: TCreateForeignUserRequest) =>
	await api.post('/foreign/user/create', data);
/* ---- FOREIGN USER END---- */

/* ---- FOREIGN APPLICANT START---- */
export const getForeignApplicantList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	...rest
}: GetForeignApplicantListParams) =>
	await api.post(
		`/foreign/applicant/list?${jsonToUrlParams({ page, pageSize, allData, sortSql })}`,
		rest
	);

export const getForeignApplicantDetail = async (id: number) =>
	await api.get(`/foreign/applicant/${id}/detail`);

export const deleteForeignApplicant = async (ids: number[]) =>
	await api.post('/foreign/applicant/delete', ids);

export const createForeignApplicant = async (
	data: TCreateForeignApplicantRequest
) => await api.post('/foreign/applicant/create', data);

export const getForeignApplicantProgramList = (
	params: GetForeignApplicantListsDetailParams
) =>
	api.get<GetForeignApplicantProgramListResponse>(
		`/foreign/applicant/${params.id}/program/list`,
		{
			params: trimObjectValues(params),
		}
	);

export const resetPassword = async (id: number) =>
	await api.post('/foreign/applicant/reset', id);

/* ---- FOREIGN APPLICANT END---- */

/* ----  FOREIGN PROGRAM START ---- */

export const getForeignProgramList = async ({
	page,
	pageSize,
	allData = false,
	sortSql = '',
	...rest
}: GetForeignProgramListParams) =>
	await api.post<GetForeignProgramListResponse>(
		`/foreign/program/list?${jsonToUrlParams({
			page,
			pageSize,
			allData,
			sortSql,
		})}`,
		rest
	);

export const getForeignProgramDetail = async (id: number) =>
	await api.get<GetForeignProgramDetailResponse>(
		`/foreign/program/${id}/detail`
	);

export const getForeignProgramApplicantList = async (
	id: number,
	params: GetForeignProgramApplicantListParams
) => {
	return await api.get<GetForeignProgramApplicantListResponse>(
		`/foreign/program/${id}/applicant/list?${jsonToUrlParams(removeNilOrEmptyObj(params))}`
	);
};

/* ----  FOREIGN PROGRAM END ---- */
